const baseUrl = 'wl-soma-dev-external-partner.azurewebsites.net';

const authGateway = 'apim-dev.somavantagens.com.br/auth';

const wlGateway = 'wl-soma-dev-api-participant.azurewebsites.net';

export const GATEWAY_SOMA = `https://${baseUrl}/v1`;
export const GATEWAY_SOMA_WL = `https://${wlGateway}/v1`;
export const GATEWAY_SOMA_AUTH = `https://${authGateway}/v1`;

export const environment = {
  production: false,
  ENV_NAME: 'default',
  TOKEN_BASE: `${GATEWAY_SOMA_AUTH}/tokens`,
  REPORT_BASE: `${GATEWAY_SOMA}/report`,
  REWARD_RESERVE_BASE: `${GATEWAY_SOMA}/reward/reserve`,
  STATUS_BASE: `${GATEWAY_SOMA}/status`,
  ENROLLMENT_BASE: `${GATEWAY_SOMA_WL}/enrollment`,
  REWARDS_BASE: `${GATEWAY_SOMA_WL}/rewards`,
  TENANT_BASE: `${GATEWAY_SOMA_WL}/tenants`,
  SERVICE_ORDERS_BASE: `${GATEWAY_SOMA}/service-orders`,
  auth_params: {
    reporterCode: 'YlIGCnNQ81Yv7NgNy3aQ4SZW/MdMOTwCgGIV9mBwbRH0z8S3ZArMxA==',
    xConsumerId: 'f6126946-826c-4fef-8afe-8b841fe6cb37',
    consumerToken: '21F905BE-58CE-4BB8-A868-2EBAB5BFB2F3',
  },
};
